// extracted by mini-css-extract-plugin
module.exports = {"chart":"styles_chart__G01uz","choreLabel":"styles_choreLabel__2z7qM","choreBlock":"styles_choreBlock__2pRgt"};